<template>
    <section class="bg-white mt-5 mb-5">
        <div class="container py-5">
            <div class="row">
                <div class="col-12 mb-3 text-center">
                    <h3 class="text-dark text-uppercase">PARTNER EDIZIONE 2023-2024</h3>
                </div>

                
                <div class="col-6 col-md-auto border-right py-2 d-flex align-items-center justify-content-center px-3 px-md-5">
                    <a href="https://garage.pizza/lievitamente/effeuno" target="_blank">
                        <img src="../assets/partner/effe-uno.png" class="img-fluid">
                    </a>
                </div>
                <div class="col-6 col-md-auto py-2 no-border d-flex align-items-center justify-content-center px-3 px-md-5">
                    <a href="https://garage.pizza/lievitamente/farinevigevano" target="_blank">
                        <img src="../assets/partner/molino-vigevano.svg" class="img-fluid w-100">
                    </a>
                </div> 
             
                <!--
                <div class="col-6 col-md-auto border-right py-2 no-border border-top d-flex align-items-center justify-content-center">
                    <a href="https://garage.pizza/lievitamente/fiordagerola" target="_blank">
                        <img src="../assets/partner/agerola-1024x576.png" class="img-fluid">
                    </a>
                </div>
                
                <div class="col-6 col-md-auto py-2 border-top border-left no-border d-flex align-items-center justify-content-center">
                    <a href="https://garage.pizza/lievitamente/emme" target="_blank">
                        <img src="../assets/partner/emme.png" class="img-fluid w-100">
                    </a>
                </div>
                -->
            </div>

            <div class="row mt-5">
                <div class="col-12 mb-3 text-center">
                    <h3 class="text-dark text-uppercase">media partner</h3>
                </div>
                <div class="col-6 col-md-auto border-right py-2 d-flex align-items-center justify-content-center">
                    <a href="https://garage.pizza/lievitamente/dissapore" target="_blank">
                        <img src="../assets/media/dissapore.png" class="img-fluid">
                    </a>
                </div>
                <div class="col-6 col-md-auto border-right py-2 d-flex align-items-center justify-content-center">
                    <a href="https://garage.pizza/lievitamente/pizzaontheroad" target="_blank">
                        <img src="../assets/media/pizza-on-the-road.png" class="img-fluid">
                    </a>
                </div>
                <div class="col-6 col-md-auto border-right py-2 no-border border-top d-flex align-items-center justify-content-center">
                    <a href="https://garage.pizza/lievitamente/foodclub" target="_blank">
                        <img style="max-height: 143px;" src="../assets/media/food-club.png" class="img-fluid">
                    </a>
                </div>
                <div class="col-6 col-md-auto border-right py-2 no-border border-top  d-flex align-items-center justify-content-center">
                    <a href="https://garage.pizza/lievitamente/pizzadixit" target="_blank">
                        <img style="max-height: 143px;" src="../assets/media/dixit.png" class="img-fluid">
                    </a>
                </div>
                <div class="col-6 col-md-auto border-top no-border d-flex align-items-center justify-content-center py-2">
                    <a href="http://www.chepizzapodcast.it" target="_blank" rel="nofollow">
                        <img style="max-height: 143px;"
                        src="../assets/media/che-pizza.svg" class="img-fluid w-100">
                    </a>
                </div>
                <div class="col-6 col-md-auto py-2 border-top border-left no-border d-flex d-sm-none align-items-center justify-content-center">
                    <a href="https://garage.pizza/" target="_blank">
                        <img src="../assets/partner/garage.pizza.png" class="img-fluid w-100">
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
export default {
  name: 'PartnerMedia'
}
</script>

<style scoped>

.no-border {
    border-top:0!important;
}

@media (max-width: 575.98px) { 

    .no-border {
        border-top: 1px solid #dee2e6!important;
    }

 }


 @media (min-width: 768px) {
    .col-md-auto {
        -ms-flex-preferred-size: 0;
        flex-basis: 0;
        -ms-flex-positive: 1;
        flex-grow: 1;
        max-width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/PartnerMedia.vue